import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    presupuesto: {},
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.presupuesto = {};
    },
    'SET_DATOS' (state, presupuesto) {
        let documentoNumero = presupuesto.clienteDocumentoNumero;
        if (presupuesto.clienteDocumentoTipoId == 2) {
            /* CUIT */
            documentoNumero = helpers.methods.formattedCuit(presupuesto.clienteDocumentoNumero);
        }
        
        let showLocalidad = true;
        if (presupuesto.clientePaisId != 1) {
            showLocalidad = false;
        }

        let showLeyendaIVA = true;
        if (presupuesto.condicionFiscalId == 3) {
            showLeyendaIVA = false;
        }

        let ivaIncluido = false;
        if (presupuesto.condicionFiscalId == 4) {
            ivaIncluido = true;
            showLeyendaIVA = false;
        }

        /* Calculamos los totales por tipo de servicio */
        let categoriasServicio = [];
        if ((/true/i).test(presupuesto.discriminarCategoriaServicio)) {
            presupuesto.ordenesTrabajos.forEach(ordenTrabajo => {
                let categoriaServicio = categoriasServicio.find(categoria => categoria.id == ordenTrabajo.categoriaServicioId);
                if (categoriaServicio) {
                    categoriaServicio.total += ordenTrabajo.cotizacion - ordenTrabajo.importeDescuento;
                } else {
                    categoriasServicio.push({
                        id: ordenTrabajo.categoriaServicioId,
                        nombre: ordenTrabajo.categoriaServicio,
                        total: ordenTrabajo.cotizacion - ordenTrabajo.importeDescuento
                    })
                }
            });
        }

        let presupuestoSugerido = false;
        if (moment(presupuesto.fechaConfirmacion).format('YYYY-MM-DD') == '1900-01-01') {
            presupuesto.ordenesTrabajos.forEach(ordenTrabajo => {
                if (ordenTrabajo.alternativas) {
                    if (ordenTrabajo.alternativas.length != 0) {
                        presupuestoSugerido = true;
                    }
                }
            });
        }

        state.presupuesto = {
            numero: presupuesto.numero,
            adicionalNumero: presupuesto.adicionalNumero,
            fecha: new Date(),
            cliente: presupuesto.cliente,
            contacto: presupuesto.clienteContacto,
            clienteRazonSocial: presupuesto.clienteRazonSocial,
            clienteCondicionFiscal: presupuesto.condicionFiscal,
            clienteDocumentoTipo: presupuesto.clienteDocumentoTipo,
            clienteDocumentoNumero: documentoNumero,
            clienteDireccion: presupuesto.clienteDireccion,
            clienteLocalidad: presupuesto.clienteLocalidad,
            clienteProvincia: presupuesto.clienteProvincia,
            clientePais: presupuesto.clientePais,
            showLocalidadCliente: showLocalidad,
            accion: presupuesto.accion,
            feeAgencia: presupuesto.feeAgencia,
            feeAgenciaPremios: presupuesto.feeAgenciaPremios,
            discriminarFee: presupuesto.discriminarFee,
            ocultarLeyendaFee: presupuesto.ocultarLeyendaFee,
            cotizacion: presupuesto.cotizacionTotal,
            importeDescuentoRebate: presupuesto.importeDescuentoRebate,
            pjeFinanciacion: presupuesto.pjeFinanciacion,
            importeFinanciacion: presupuesto.importeFinanciacion,
            discriminarPjeFinanciacion: presupuesto.discriminarPjeFinanciacion,
            feeSobreFinanciacion: presupuesto.feeSobreFinanciacion,
            importeFee: presupuesto.importeFee,
            importeFeePremios: presupuesto.importeFeePremios,
            importeNeto: presupuesto.importeNeto,
            importeImpuestos: presupuesto.importeImpuestos,
            importeDescuento: presupuesto.importeDescuento,
            importeTotal: presupuesto.importeTotal,
            numeroOrdenCompra: presupuesto.numeroOrdenCompra,
            descripcionOrdenCompra: presupuesto.descripcionOrdenCompra,
            showLeyendaIVA,
            ivaIncluido,
            pjeIva: presupuesto.pjeIva,
            moneda: presupuesto.moneda,
            monedaCotizacion: presupuesto.monedaCotizacion,

            discriminarCategoriaServicio: presupuesto.discriminarCategoriaServicio,
            categoriasServicio,

            prontoPagoFeeDiferenciado: presupuesto.prontoPagoFeeDiferenciado,
            /* 2023-11-10: Solo mostramos el monto correspondiente a las órdenes */
            importeNetoProntoPago: parseFloat(presupuesto.cotizacionTotalFeeDiferenciado),
            // importeNetoProntoPago:parseFloat(presupuesto.cotizacionTotalFeeDiferenciado)
            //     + parseFloat(presupuesto.importeFeePremios),
            
            renglones:  presupuesto.ordenesTrabajos,

            presupuestoSugerido
        }
            
        console.log(state.presupuesto);
    },
};

const getters = {
    getField,

    presupuesto (state) {
        return state.presupuesto;
    },
};

const actions = {
    getPresupuestoCliente ( { commit }, presupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            if (presupuestoId) {
                apiAxios.get(`presupuestosinternos/${presupuestoId}/presupuesto-cliente`) 
                    .then(res => {
                        commit('SET_DATOS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}